import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import "./stylesheet/AdminLogin.css";
import logoImg from "../assets/logo.svg"; 

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false); // Novo estado
  const [errorMessage, setErrorMessage] = useState(""); // Novo estado
  const navigate = useNavigate();

  async function handleLogin() {
    if (!username || !password) {
      setErrorMessage("Por favor, preencha todos os campos para acessar o painel.");
      setShowError(true);
      return;
    }

    try {
      const res = await api.post("auth/adminLogin.php", {
        username,
        password,
      });

      if (res.data.success) {
        localStorage.setItem("admin", JSON.stringify(res.data.data));
        navigate("/admin/dashboard");
      } else {
        setErrorMessage(res.data.message || "Credenciais incorretas.");
        setShowError(true);
      }
    } catch (error) {
      setErrorMessage("Falha na conexão com o servidor. Tente novamente.");
      setShowError(true);
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') handleLogin();
  };

  return (
    <div className="admin-login-container">
      <div className="login-card">
        <div className="login-logo-container">
          <img src={logoImg} alt="HelpDesk Logo" className="login-logo" />
        </div>

        <h1 className="login-title">Acesso Administrativo</h1>
        <p className="login-subtitle">Entre com suas credenciais para continuar.</p>

        <input
          type="text"
          placeholder="Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="login-input"
        />

        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
          onKeyDown={handleKeyDown}
        />

        <button onClick={handleLogin} className="login-button">
          Entrar
        </button>

        <button onClick={() => navigate("/")} className="back-link">
          Voltar para Central de Suporte
        </button>
      </div>
       {/* RODAPÉ DO DESENVOLVEDOR */}
      
      
      {/* POPUP ANIMADO DE ERRO */}
      {showError && (
        <div className="error-overlay">
          <div className="error-popup-card">
            <h3>Erro de Acesso</h3>
            <p>{errorMessage}</p>
            <button className="error-close-btn" onClick={() => setShowError(false)}>
              Entendido
            </button>
          </div>
        </div>
      )}
    </div>
  );
}